var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},_vm._l((_vm.games),function(game){return _c('li',{key:game.id,staticClass:"list-group-item pointer",on:{"click":function($event){_vm.addGame(game)}}},[_vm._v("\n        "+_vm._s(game.name)+"\n    ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }